import React from 'react';
import { Grid } from '@material-ui/core';

import styles from './css/SelectedContainer.module.css';
import StyledChip from '../../../common/CustomMaterial/StyledChip';

const SelectedContainer = ({ items, onRemove, maxChars }) => {
    const chipLabel = (text) => {
        let textToShow = text;
        if (textToShow.length > maxChars) {
            textToShow = `${textToShow.slice(0, maxChars)}...`;
        }
        return textToShow;
    };
    const chips = [];
    for (const item of items) {
        const chipId = `chipSelected_${item}`;

        const chip = (
            <Grid key={`selected-container-grid-${chipId}`}>
                <div className={styles.chipContainer}>
                    <StyledChip
                        key={chipId}
                        id={chipId}
                        label={chipLabel(item)}
                        color="primary"
                        variant="outlined"
                        size="small"
                        onDelete={(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                            onRemove(item);
                        }}
                        className={styles.chip}
                    />
                </div>
            </Grid>
        );

        chips.push(chip);
    }

    const isChips = !!chips.length;
    return (
        <div>
            {isChips && (
                <Grid container direction="row">
                    {chips}
                </Grid>
            )}
            {!isChips && <div>No Values...</div>}
        </div>
    );
};

export default SelectedContainer;
